import React from "react";

const HeroSkeleton = () => (
  <section className="placeholder-glow mb-5">
    <div className="bg-secondary" style={{ height: 520, opacity: 0.2, borderRadius: 8 }} />
  </section>
);

export default HeroSkeleton;
